import isMap from'./isMap';export default function get(key,x){return isMap(x)?x.get(key):x[key];}